<template>
  <div class="connect-agent">
    <!-- 侧边栏与主内容区 -->
    <div class="flex max-w-7xl mx-auto px-4 py-8">
      <!-- 侧边栏 -->
      <aside class="w-56 mr-8 hidden md:block">
        <nav class="space-y-2">
          <a 
            v-for="(section, index) in sections" 
            :key="index"
            :href="`#${section.id}`"
            :class="[
              'block px-4 py-2 rounded-lg',
              activeSection === section.id 
                ? 'bg-indigo-50 text-indigo-700 font-bold' 
                : 'hover:bg-indigo-50'
            ]"
            @click.prevent="scrollToSection(section.id)"
          >
            {{ $store.getters.t(section.label) }}
          </a>
        </nav>
      </aside>
      
      <!-- 主内容区 -->
      <main class="flex-1 space-y-8">

        <!-- 线索池/流转 -->
        <section id="clue" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-database text-green-600 mr-2"></i>
              {{ $store.getters.t('clue_pool') }}
            </h2>
            <button 
              @click="goToClueManagement"
              class="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
            >
              <i class="fas fa-sync-alt mr-2"></i>
              {{ $store.getters.t('clue_flow') }}
            </button>
          </div>
          <p class="text-gray-600 mb-4">{{ $store.getters.t('clue_desc') }}</p>
          <button class="bg-green-100 text-green-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-green-200">
            <i class="fas fa-magic mr-1"></i>
            {{ $store.getters.t('ai_clue') }}
          </button>
        </section>
        
        <!-- 账号分配 -->
        <section id="account" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-user-plus text-indigo-600 mr-2"></i>
              {{ $store.getters.t('account_assign') }}
            </h2>
            <button class="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700">
              <i class="fas fa-plus mr-2"></i>
              {{ $store.getters.t('add_account') }}
            </button>
          </div>
          <p class="text-gray-600 mb-4">{{ $store.getters.t('account_assign_desc') }}</p>
          <button class="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-indigo-200">
            <i class="fas fa-magic mr-1"></i>
            {{ $store.getters.t('ai_assign') }}
          </button>
        </section>
        
        <!-- 沟通与联系 -->
        <section id="contact" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-comments text-blue-600 mr-2"></i>
              {{ $store.getters.t('contact') }}
            </h2>
            <button class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
              <i class="fas fa-envelope mr-2"></i>
              {{ $store.getters.t('add_contact') }}
            </button>
          </div>
          <p class="text-gray-600 mb-4">{{ $store.getters.t('contact_desc') }}</p>
          <button class="bg-blue-100 text-blue-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-blue-200">
            <i class="fas fa-magic mr-1"></i>
            {{ $store.getters.t('ai_contact') }}
          </button>
        </section>
        
        <!-- 转化与签约 -->
        <section id="convert" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-file-signature text-yellow-600 mr-2"></i>
              {{ $store.getters.t('convert') }}
            </h2>
            <button class="bg-yellow-600 text-white px-4 py-2 rounded-lg hover:bg-yellow-700">
              <i class="fas fa-file-contract mr-2"></i>
              {{ $store.getters.t('add_contract') }}
            </button>
          </div>
          <p class="text-gray-600 mb-4">{{ $store.getters.t('convert_desc') }}</p>
          <button class="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-yellow-200">
            <i class="fas fa-magic mr-1"></i>
            {{ $store.getters.t('ai_convert') }}
          </button>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConnectAgent',
  data() {
    return {
      activeSection: 'clue',
      sections: [
        { id: 'clue', label: 'clue_pool' },
        { id: 'account', label: 'account_assign' },
        { id: 'contact', label: 'contact' },
        { id: 'convert', label: 'convert' }
      ]
    }
  },
  mounted() {
    // 监听滚动事件，更新活动区域
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const sections = this.sections.map(s => s.id)
      const scrollPosition = window.scrollY + 100
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const element = document.getElementById(sections[i])
        if (element && element.offsetTop <= scrollPosition) {
          this.activeSection = sections[i]
          break
        }
      }
    },
    scrollToSection(sectionId) {
      this.activeSection = sectionId
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    goToClueManagement() {
      this.$router.push('/clue-management')
    }
  }
}
</script>

<style scoped>
.connect-agent {
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
}

.flex {
  display: flex;
}

.max-w-7xl {
  max-width: 80rem;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.w-56 {
  width: 14rem;
}

.mr-8 {
  margin-right: 2rem;
}

.hidden {
  display: none;
}

@media (min-width: 768px) {
  .md\:block {
    display: block;
  }
}

.flex-1 {
  flex: 1 1 0%;
}

.space-y-8 > * + * {
  margin-top: 2rem;
}

.space-y-2 > * + * {
  margin-top: 0.5rem;
}

.block {
  display: block;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.bg-indigo-50 {
  background-color: #eef2ff;
}

.text-indigo-700 {
  color: #4338ca;
}

.font-bold {
  font-weight: 700;
}

.hover\:bg-indigo-50:hover {
  background-color: #eef2ff;
}

.bg-white {
  background-color: #ffffff;
}

.shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.p-6 {
  padding: 1.5rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mr-1 {
  margin-right: 0.25rem;
}

.text-xl {
  font-size: 1.25rem;
}

.text-gray-600 {
  color: #4b5563;
}

.text-indigo-600 {
  color: #4f46e5;
}

.text-green-600 {
  color: #16a34a;
}

.text-blue-600 {
  color: #2563eb;
}

.text-yellow-600 {
  color: #ca8a04;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.flex {
  display: flex;
}
</style> 